import * as React from "react";
import { AggregateCard } from "../AggregateCard";
import { EventCardAmerican } from "../EventCardAmerican";
import { EventCardMultiview } from "../EventCardMultiview";
import { EventCardRegular } from "../EventCardRegular";
import { LiveOutright } from "../LiveOutright";
import { MiniEventCardAmerican } from "../MiniEventCardAmerican";
import { MiniEventCardRegular } from "../MiniEventCardRegular";
import { MiniLiveOutright } from "../MiniLiveOutright";
import { PreliveOutrightWrap } from "../PreliveOutrightWrap";
export class EventCardPicker extends React.PureComponent {
    getCardType() {
        const ComponentTypeMap = {
            AggregateCard,
            EventCardAmerican,
            EventCardMultiview,
            EventCardRegular,
            MiniEventCardAmerican,
            MiniEventCardRegular,
            MiniLiveOutright,
            LiveOutright,
            PreliveOutright: PreliveOutrightWrap
        };
        return this.props.event.cardType
            ? ComponentTypeMap[`${this.props.event.componentType}${this.props.event.cardType}`]
            : ComponentTypeMap[this.props.event.componentType];
    }
    render() {
        const CardTypeComp = this.getCardType();
        return React.createElement(CardTypeComp, Object.assign({}, this.props));
    }
}
//# sourceMappingURL=EventCardPicker.js.map